import { getUserByIdQuery } from '@util/firestore/users';
import { onSnapshot } from 'firebase/firestore';
import { UserDocument } from 'models/user';
import { useEffect, useMemo, useState } from 'react';

const useRealTimeUser = (uid?: string) => {
  const [realTimeUser, setRealtimeUser] = useState<UserDocument | null>(null);
  const userQuery = useMemo(() => (uid ? getUserByIdQuery(uid) : null), [uid]);
  useEffect(() => {
    if (!uid || !userQuery) return;
    const unsubscribe = onSnapshot(userQuery, (snapshot) => {
      const realTimeData = snapshot.docs[0]?.data() as UserDocument;
      setRealtimeUser(realTimeData);
    });
    return () => {
      unsubscribe();
    };
  }, [userQuery, uid]);

  return realTimeUser;
};

export default useRealTimeUser;
